import { Body, Row } from '@alto/design-system';
import React from 'react';
import { TypescriptUtils } from '~shared/TypescriptUtils';
import { type PlaidData } from '~shared/types';

type Props = {
  plaidData: PlaidData;
};

export const ACHLabel = ({ plaidData }: Props) => {
  const { institution_name, account_name, account_mask } = plaidData;

  return (
    <Row flexShrink={1}>
      <Body fontFamily="bold">{institution_name} </Body>
      <Body>{[account_name, account_mask].filter(TypescriptUtils.isPresent).join(' ')}</Body>
    </Row>
  );
};
